import React from 'react';
import { Link, Button, Skeleton } from '@nextui-org/react';
import { useTranslation } from '@/layers/presentation/i18n/client';
import { Program } from '@/types/models';
import { Card, CardFooter, CardBody, CardHeader } from '@/layers/presentation/components/ui/Card';

type ProgramPreviewCardProps = {
  program: Program;
  typeUrl: string;
  onCardPress: (id: number) => void;
  isLoadingProgram: boolean;
  isShowDetailsButton?: boolean;
};

const ProgramPreviewCard: React.FC<ProgramPreviewCardProps> = ({
  program,
  typeUrl,
  onCardPress,
  isLoadingProgram,
  isShowDetailsButton = true,
}) => {
  const { t } = useTranslation();

  const handlePress = () => {
    onCardPress(program.id);
  };

  return (
    <Card>
      {program?.sponsor_name && <CardHeader>{program?.sponsor_name}</CardHeader>}
      <CardBody>
        <Skeleton isLoaded={!isLoadingProgram} className="rounded-lg mb-4">
          <h4 className="mb-0 pb-0">{program?.name || ' '}</h4>
        </Skeleton>
        <Skeleton isLoaded={!isLoadingProgram} className="rounded-lg">
          <p className="mb-4">{program?.lead}</p>
        </Skeleton>
      </CardBody>
      {isShowDetailsButton && (
        <CardFooter>
          <div className="w-full flex flex-row justify-end items-center">
            <Button
              as={Link}
              size="sm"
              radius="sm"
              variant="bordered"
              color="primary"
              href={`/${typeUrl}/programs/${program.id}`}
            >
              {t('provider:programApply.viewProgram')}
            </Button>
          </div>
        </CardFooter>
      )}
    </Card>
  );
};

export default React.memo(ProgramPreviewCard);
